var items = document.querySelectorAll('.logo-slider--slider_image').length;

var logo_slider = tns({
    container: '.logo-slider--slider',
    items: 2,
    slideBy: 1,
    nav: false,
    controls:false,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayHoverPause: false,
    speed: 4000,
    //autoplayTimeout: 0,
    loop:true,
    responsive: {
      768: {
        items: items > 3 ? '3' : items,
      },
      991: {
        items: items > 5 ? '5' : items,
      },
      1200: {
        items: items > 7 ? '7' : items,
      }
    }
});